import React from "react";
import { Routes, Route } from "react-router-dom";

import RequireAuth from "./private-router";
import NotRequireAuth from "./public-router";

import ListContentCenter from "../pages/content-center";
import ViewContent from "../pages/view-content";
import Profile from "../pages/profile";
import Login from "../pages/login";
import TermsOfService from "../pages/terms-of-service";
import ConfirmInvivation from "../pages/confirm-invivation";
import RecoverPassword from "../pages/recover-password";
import SignUp from "../pages/signup";
import PageEditProfile from "../pages/edit-profile";
import Properties from "../pages/properties";
import CreateProperty from "../pages/create-property";
import EditProperty from "../pages/edit-property";
import ViewProperty from "../pages/view-property";
import Animals from "../pages/animals";
import EditAnimal from "../pages/edit-animal";
import CreateAnimal from "../pages/create-animal";
import ViewAnimal from "../pages/view-animal";
import ViewCollaborators from "../pages/collaborators";
import NewCollaborator from "../pages/new-collaborator";
import Invivation from "../pages/invivation";
import ListTasks from "../pages/list-tasks";
import CreateTask from "../pages/create-task";
import HistoryTask from "../pages/history-task";
import Managements from "../pages/managements";
import CreateManagement from "../pages/create-management";
import ViewManagement from "../pages/view-management";
import EditManagement from "../pages/edit-management";

const Router = () => (
  <Routes>
    <Route element={<NotRequireAuth />}>
      <Route index element={<Login />} />
      <Route path="/recover-password" element={<RecoverPassword />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/confirm-invivation" element={<ConfirmInvivation />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
    </Route>

    <Route element={<RequireAuth />}>
      <Route path="/content-center" element={<ListContentCenter />} />
      <Route path="/content-center/:id" element={<ViewContent />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/profile/edit/:id" element={<PageEditProfile />} />

      <Route path="/properties" element={<Properties />} />
      <Route path="/properties/:id" element={<ViewProperty />} />
      <Route path="/properties/edit/:id" element={<EditProperty />} />
      <Route path="/properties/create" element={<CreateProperty />} />

      <Route path="/animals" element={<Animals />} />
      <Route path="/animals/edit/:id" element={<EditAnimal />} />
      <Route path="/animals/create" element={<CreateAnimal />} />
      <Route path="/animals/:id" element={<ViewAnimal />} />

      <Route path="/collaborators" element={<ViewCollaborators />} />
      <Route path="/collaborators/new" element={<NewCollaborator />} />
      <Route
        path="/collaborators/invitation/:type/:id"
        element={<Invivation />}
      />
      <Route path="/tasks" element={<ListTasks />} />
      <Route path="/tasks/create" element={<CreateTask />} />
      <Route path="/tasks/history/:id" element={<HistoryTask />} />

      <Route path="/managements" element={<Managements />} />
      <Route path="/managements/create" element={<CreateManagement />} />
      <Route path="/managements/:id" element={<ViewManagement />} />
      <Route path="/managements/edit/:id" element={<EditManagement />} />
    </Route>
  </Routes>
);

export default Router;
